export enum ColumnSizes {
  XS = 100,
  MD = 150,
  LG = 200,
  XL = 300,
}
